export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
  },
  {
    field: 'expand',
    type: 'expand',
    width: 75,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: { content: 'expandContent' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_evgBulkOrderNo') || '大货订单编号',
    field: 'evgBulkOrderNo',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_evgBulkOrderStatus') || '状态',
    field: 'evgBulkOrderStatus',
    minWidth: 100,
    align: 'center',
    slots: { default: 'status' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custOrderNo') || '客户订单号',
    field: 'custOrderNo',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custName') || '客户',
    field: 'custName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    slots: { default: 'displayCustomer' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_scm') || '采购工厂',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_outBillType') || '出单类型',
    field: 'v_outBillType',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderDate') || '订单日期',
    field: 'orderDate',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_deliveryDate') || '交货日期',
    field: 'deliveryDate',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_beginShippingDate') || '最早发运日期',
    field: 'beginShippingDate',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_endShippingDate') || '最晚发运日期',
    field: 'endShippingDate',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_totalGoodsQty') || '总产品数量',
    field: 'totalGoodsQty',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalAmount') || '订单总金额',
    field: 'totalAmount',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_modifyByName') || '需求提交人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_modifyDate') || '需求时间',
    field: 'modifyDate',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
